import React from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import { Blog } from '@/commonTypes';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import { avatarBg, blogBg } from '@/functions/formats';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import ViewCount from './ViewCount';
import AppLink from '@/components/common/AppLink';
import BlogFooter from './BlogFooter';
import BlogCover from './BlogCover';

type BlogCardProps = {
  item: Blog;
  direction?: 'vertical' | 'horizontal';
  className?: string;
  featured?: boolean;
  index?: number;
};

export default function BlogCard({
  item,
  direction = 'vertical',
  className = '',
  featured = false,
  index,
}: BlogCardProps) {
  return (
    <AppLink
      key={item?.title}
      href={'/blogs/' + item?.slug}
      className={`${styles.card} ${direction == 'horizontal' && styles.horizontalCard} movingCard ${className}`}
    >
      <BlogCover item={item} index={index} featured={featured} size="thumbnail" />
      <div className={`${styles.body}  ${featured && styles.featuredBody}`}>
        {featured && <span className={`${styles.featuredTag}`}>مقاله برگزیده</span>}
        <h3 className={`${styles.cardTitle} ${featured && styles.featuredTitle}`}>{item?.title}</h3>
        <p className={`${styles.excerpt} ${featured && styles.featuredText}`}>{item?.excerpt}</p>
        <div className={`${styles.footer}`}>
          <BlogFooter item={item} index={index} featured={featured} />
          {featured ? (
            <div className={`${styles.moreButton}`}>
              <MainIcons.arrowLongIcon fill="var(--brand-deep)" width="19px" height="19px" />
            </div>
          ) : (
            <ViewCount count={item?.viewNum} />
          )}
        </div>
      </div>
    </AppLink>
  );
}
